import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import PlusSVG from "../../../../../media/images/icons/plus";
import TicketCard from "./TicketCard";
import ButtonTabbar from "../../../../components/ButtonTabbar";

export default function TicketsBox() {
  const theme = useTheme();

  const [tabbuttons, setTabbuttons] = useState([
    {
      title: "همه درخواست‌ها",
      active: true,
    },
    {
      title: "درخواست‌های باز",
      active: false,
    },
    {
      title: "بسته شده",
      active: false,
    },
  ]);

  const [tabIndex, setTabIndex] = useState(1);

  return (
    <Box
      sx={{
        marginTop: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
        }}
      >
        برای ارتباط با پشتیبان بازارگاه می‌توانید درخواست خود را در فرم پرکنید و
        کارشناسان ما در اولین زمان پاسخ درخواست شما را خواهند داد.
      </Typography>
      <Link
        to={"/"}
        style={{
          marginTop: "8px",
          backgroundColor: theme.palette.success.main,
          justifyContent: "center",
          padding: "16px 8px",
          borderRadius: "16px",
          display: "flex",
          width: "80%",
          margin: "auto",
          gap: "8px",
        }}
      >
        <Box>
          <PlusSVG color={theme.palette.success.light} />
        </Box>
        <Typography
          sx={{
            color: "#ffffff",
          }}
        >
          ایجاد درخواست پشتیبانی جدید
        </Typography>
      </Link>

      <Box
        sx={{
          marginTop: "32px",
          //   border: "1px solid gray",
        }}
      >
        <Box
          sx={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "8px 0px",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              color: "primary.main",
              fontWeight: "600",
            }}
          >
            درخواست‌های پشتیبانی
          </Typography>
        </Box>
        <ButtonTabbar
          activeIndex={tabIndex}
          handleChangeTab={(index) => setTabIndex(index)}
          buttons={tabbuttons}
        />
        <Box
          sx={{
            // border: "1px solid gray",
            marginTop: "8px",
            overflow: "auto",
            maxHeight: "50vh",
            marginBottom: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "8px 8px",
          }}
        >
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
          <TicketCard />
        </Box>
      </Box>
    </Box>
  );
}
